<template>
  <div class="w-screen md:w-full mx-auto overflow-hidden" style="position:relative;">
    <div v-if="$isMobile() && mobileBanner">
      <a :href="mobileBanner.url">
        <img :src="mobileBanner.main_image" itemprop="thumbnail">
      </a>

    </div>
    <!--    <div class="flex flex-row items-center mb-8 border-b">-->
    <!--      <h2 class="text-4xl text-gray-900">{{ content[0].main_header }}</h2>-->
    <!--    </div>-->
    <flickity id="slider" v-if="!$isMobile() && slide" class="main-carousel" ref="flickity"
              :options="flickityOptions">
      <!--            <div class="carousel-cell" style="max-height: 500px">-->
      <!--              <a  href="https://dependentdearta.artmark.ro/ro/categories/bijuterie-ceasuri">-->
      <!--              <video autoplay loop muted class="carousel-cell-image">-->
      <!--                <source src="../../../../../../public/assets/img/dda/dda_slider.mp4" type="video/mp4">-->
      <!--              </video>-->
      <!--              </a>-->
      <!--            </div>-->
      <div v-for="s in slide" class="carousel-cell">
        <a v-if="s.url" :href="s.url">
          <img :data-flickity-lazyload="s.main_image" class="carousel-cell-image">
          <!--          <div class="caption-slider-landing">-->
          <!--            <h4 v-if="s.title" class="text-right landing-responsive-h5 col-12 px-3 slider-title">{{ s.title }}</h4>-->
          <!--            <h5 v-if="s.description" class="text-right landing-responsive-h6 col-12 px-3 slider-desc"-->
          <!--                v-html="s.description"></h5>-->
          <!--          </div>-->
        </a>
      </div>
    </flickity>

    <div v-if="featuredIds.length > 0" ref="highlights"
         class="flex flex-col  w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">{{ content[0].highlights }}</h2>
      <div class="-mx-3">
        <div class="flex flex-wrap mb-3" style="justify-content: space-between;">
          <button :disabled="featuredPage < 1" @click="getFeatured(featuredIds[featuredPage -1], 'prev')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <button :disabled="featuredPage >= featuredIds.length - 1"
                  @click="getFeatured(featuredIds[featuredPage +1], 'next')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round"
                 stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
        <div class="flex flex-wrap">
          <div v-for="(lot, index) in featured" :key="index" class="p-3 w-full md:w-1/2 lg:w-1/3 group">
            <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)"><img
                class="transform group-hover:scale-105 transition ease-in-out duration-150"
                :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/></inertia-link>
            <div class="pt-6 flex justify-between items-start">
              <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                  class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150"
                  v-html="makeLotTitle(lot, true)"></h2></inertia-link>
              <div :id="'addToCart_wrapper_' + lot.id">
                <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                        class="btn-gray ">{{ $t('cart.add_cart') }}
                </button>
                <a :href="route('shop.cart.view')"
                   v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                   class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
              </div>
            </div>
            <div class="flex justify-between items-center pt-3">
              <div>
                <h4 class="a10-lot-listing-author">
                  <span v-html="makeArtistLink(lot.artists)"></span>
                  <div v-if="!lot.artists && lot.old_artist">
                    {{ lot.old_artist }}
                  </div>
                </h4>
                <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                  {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
                </h4>
                <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.shop_discount_price"><s>{{
                      $t('cart.sell_price')
                    }}: &euro; {{ lot.formatted_shop_price }}</s>
                  <br/>
                    <span style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                  <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
                </h4>

              </div>
              <div class="favShare">
                <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                    src="/assets/img/icons/3-01.png" height="20" width="20"
                    style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
                <dropdown placement="bottom-center" :overlay="false">
                  <div class="flex items-center cursor-pointer select-none group">
                    <div
                        class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                      <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                           enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                           xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                              d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                    <a :href="lot.shop_facebook_share_link"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                           width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                      <span class="pl-2">Facebook</span>
                    </a>
                    <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                      </svg>
                      <span class="pl-2">Email</span>
                    </a>
                    <div @click="copyToClipboard(lot)"
                         class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                      </svg>
                      <span class="pl-2">Copiază link-ul</span>
                    </div>
                  </div>
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="bestSellsIds.length > 0" ref="highlights"
         class="flex flex-col  w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">{{ $t('misc.top_sales') }}</h2>
      <div class="-mx-3">
        <div class="flex flex-wrap mb-3" style="justify-content: space-between;">
          <button :disabled="bestSellsPage < 1" @click="getBestSells(bestSellsIds[bestSellsPage -1], 'prev')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <button :disabled="bestSellsPage >= bestSellsIds.length - 1"
                  @click="getBestSells(bestSellsIds[bestSellsPage +1], 'next')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round"
                 stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
        <div class="flex flex-wrap">
          <div v-for="(lot, index) in bestSells" :key="index" class="p-3 w-full md:w-1/2 lg:w-1/3 group">
            <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)"><img
                class="transform group-hover:scale-105 transition ease-in-out duration-150"
                :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/></inertia-link>
            <div class="pt-6 flex justify-between items-start">
              <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                  class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150"
                  v-html="makeLotTitle(lot, true)"></h2></inertia-link>
              <div :id="'addToCart_wrapper_' + lot.id">
                <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                        class="btn-gray ">{{ $t('cart.add_cart') }}
                </button>
                <a :href="route('shop.cart.view')"
                   v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                   class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
              </div>
            </div>
            <div class="flex justify-between items-center pt-3">
              <div>
                <h4 class="a10-lot-listing-author">
                  <span v-html="makeArtistLink(lot.artists)"></span>
                  <div v-if="!lot.artists && lot.old_artist">
                    {{ lot.old_artist }}
                  </div>
                </h4>
                <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                  {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
                </h4>
                <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.shop_discount_price"><s>{{
                      $t('cart.sell_price')
                    }}: &euro; {{ lot.formatted_shop_price }}</s>
                  <br/>
                    <span style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                  <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
                </h4>

              </div>
              <div class="favShare">
                <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                    src="/assets/img/icons/3-01.png" height="20" width="20"
                    style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
                <dropdown placement="bottom-center" :overlay="false">
                  <div class="flex items-center cursor-pointer select-none group">
                    <div
                        class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                      <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                           enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                           xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                              d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                    <a :href="lot.shop_facebook_share_link"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                           width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                      <span class="pl-2">Facebook</span>
                    </a>
                    <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                      </svg>
                      <span class="pl-2">Email</span>
                    </a>
                    <div @click="copyToClipboard(lot)"
                         class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                      </svg>
                      <span class="pl-2">Copiază link-ul</span>
                    </div>
                  </div>
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="salesIds.length > 0" ref="sales"
         class="flex flex-col  w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">
        <inertia-link :href="route('shop.category.view', salesLink.slug)">{{ $t('menu.sales') }}</inertia-link>
      </h2>
      <div class="-mx-3">
        <div class="flex flex-wrap mb-3" style="justify-content: space-between;">
          <button :disabled="salesPage < 1" @click="getSales(salesIds[salesPage -1], 'prev')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <button :disabled="salesPage >= salesIds.length - 1" @click="getSales(salesIds[salesPage +1], 'next')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round"
                 stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
        <div class="flex flex-wrap">
          <div v-for="(lot, index) in sales" :key="index" class="p-3 w-full md:w-1/2 lg:w-1/3 group">
            <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)"><img
                class="transform group-hover:scale-105 transition ease-in-out duration-150"
                :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/></inertia-link>
            <div class="pt-6 flex justify-between items-start">
              <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                  class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150"
                  v-html="makeLotTitle(lot, true)">
              </h2></inertia-link>
              <div :id="'addToCart_wrapper_' + lot.id">
                <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                        class="btn-gray ">{{ $t('cart.add_cart') }}
                </button>
                <a :href="route('shop.cart.view')"
                   v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                   class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
              </div>
            </div>
            <div class="flex justify-between items-center pt-3">
              <div>
                <h4 class="a10-lot-listing-author">
                  <span v-html="makeArtistLink(lot.artists)"></span>
                  <div v-if="!lot.artists && lot.old_artist">
                    {{ lot.old_artist }}
                  </div>
                </h4>
                <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                  {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
                </h4>
                <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.shop_discount_price"><s>{{
                      $t('cart.sell_price')
                    }}: &euro; {{ lot.formatted_shop_price }}</s>
                  <br/>
                    <span style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                  <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
                </h4>

              </div>
              <div class="favShare">
                <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                    src="/assets/img/icons/3-01.png" height="20" width="20"
                    style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
                <dropdown placement="bottom-center" :overlay="false">
                  <div class="flex items-center cursor-pointer select-none group">
                    <div
                        class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                      <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                           enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                           xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                              d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                    <a :href="lot.shop_facebook_share_link"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                           width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                      <span class="pl-2">Facebook</span>
                    </a>
                    <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                      </svg>
                      <span class="pl-2">Email</span>
                    </a>
                    <div @click="copyToClipboard(lot)"
                         class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                      </svg>
                      <span class="pl-2">Copiază link-ul</span>
                    </div>
                  </div>
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="twiceDiscountedIds.length > 0" ref="twiceDiscounted"
         class="flex flex-col  w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">
        <inertia-link :href="route('shop.category.view', twiceDiscountedLink.slug)">{{
            $t('menu.twiceDiscounted')
          }}
        </inertia-link>
      </h2>
      <div class="-mx-3">
        <div class="flex flex-wrap mb-3" style="justify-content: space-between;">
          <button :disabled="twiceDiscountedPage < 1"
                  @click="getTwiceDiscounted(twiceDiscountedIds[twiceDiscountedPage -1], 'prev')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <button :disabled="twiceDiscountedPage >= twiceDiscountedIds.length -1"
                  @click="getTwiceDiscounted(twiceDiscountedIds[twiceDiscountedPage +1], 'next')">
            <svg class="w-10 h-10" fill="none" stroke-linecap="round" stroke-linejoin="round"
                 stroke-width=".5" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
        <div class="flex flex-wrap">
          <div v-if="twiceDiscountedIds.length" v-for="(lot, index) in twiceDiscounted" :key="index"
               class="p-3 w-full md:w-1/2 lg:w-1/3 group">
            <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)"><img
                class="transform group-hover:scale-105 transition ease-in-out duration-150"
                :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/></inertia-link>
            <div class="pt-6 flex justify-between items-start">
              <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                  class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150"
                  v-html="makeLotTitle(lot, true)">
              </h2></inertia-link>
              <div :id="'addToCart_wrapper_' + lot.id">
                <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                        class="btn-gray ">{{ $t('cart.add_cart') }}
                </button>
                <a :href="route('shop.cart.view')"
                   v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                   class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
              </div>
            </div>
            <div class="flex justify-between items-center pt-3">
              <div>
                <h4 class="a10-lot-listing-author">
                  <span v-html="makeArtistLink(lot.artists)"></span>
                  <div v-if="!lot.artists && lot.old_artist">
                    {{ lot.old_artist }}
                  </div>
                </h4>
                <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                  {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
                </h4>
                <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.custom_shop_price && lot.shop_price_first_discount"><s>{{ $t('cart.sell_price') }}: &euro; {{
                      lot.formatted_shop_price
                    }}</s>
                  <br/>
                    <span v-if="lot.shop_price_first_discount"><s>{{
                        $t('cart.discount_sell_price')
                      }}: &euro; {{ lot.shop_price_first_discount }}</s></span>
                    <br/>
                    <span style="color:darkred"><b>{{ $t('cart.custom_sell_price') }}: &euro; {{
                        lot.custom_shop_price
                      }}</b></span>
                  </span>
                  <span v-else-if="lot.shop_discount_price">
                    <span><s>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s></span>
                  <br/>
                    <span v-if="lot.shop_discount_price" style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{
                        lot.shop_discount_price
                      }}</span>
                  </span>
                  <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
                </h4>

              </div>
              <div class="favShare">
                <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                    src="/assets/img/icons/3-01.png" height="20" width="20"
                    style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
                <dropdown placement="bottom-center" :overlay="false">
                  <div class="flex items-center cursor-pointer select-none group">
                    <div
                        class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                      <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                           enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                           xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                              d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                    <a :href="lot.shop_facebook_share_link"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                           width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                            <path
                                d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                                data-original="#000000" class="active-path"/>
                          </svg>
                      <span class="pl-2">Facebook</span>
                    </a>
                    <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                      </svg>
                      <span class="pl-2">Email</span>
                    </a>
                    <div @click="copyToClipboard(lot)"
                         class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                           stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                      </svg>
                      <span class="pl-2">Copiază link-ul</span>
                    </div>
                  </div>
                </dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="giftCertificate" class="flex flex-col w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <div class="flex flex-row items-center mb-8 border-b">
        <h2 class="text-4xl text-gray-900">{{ $t('menu.giftCertificate') }}</h2>
      </div>

      <div class="-mx-2">
        <div class="flex flex-wrap">
          <div class="w-full">
            <a href="https://www.artmark.ro/ro/certificat-cadou" target="_blank">
              <img src="../../../../../../public/assets/img/certificat_de_arta_cadou.png" itemprop="thumbnail">
            </a>

          </div>
        </div>
      </div>
    </div>
    <div ref="categories" class="flex flex-col w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">{{ $t('menu.categories') }}</h2>
      <div class="-mx-2">
        <div class="flex flex-wrap">
          <div v-for="(category, index) in categories" :key="index" class="p-2 w-full md:w-1/2 lg:w-1/3">
            <div class="group">
              <div class="border-b">
                <inertia-link :href="route('shop.category.view', category.slug)"><img
                    :src="category.image" :alt="`Image of ${category.name}`"/></inertia-link>
              </div>
              <inertia-link :href="route('shop.category.view', category.slug)">
                <h2 class="text-lg py-2 text-gray-800 group-hover:text-black transition ease-in-out duration-150">
                  {{ category.name }}
                </h2>
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="consult" class="flex flex-col  w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">{{ $t('misc.consultants') }}</h2>
      <div class="text-gray-800 text-sm">
        <div class="flex flex-wrap">
          <div class="p-3 xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Andreea_Plugariu.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Andreea Plugariu <br/></h4>
              <p> Gallery Shop Manager <br/></p>
              <p class="mt-1"><a href="tel:+40757026455">+40 757 026 455</a>, andreea.plugariu@artmark.ro </p>
            </div>
          </div>

          <div class="p-3 xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Filip_Fagaraseanu.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Filip Făgărășeanu <br/></h4>
              <p> Shop consultant <br/></p>
              <p class="mt-1"><a href="tel:+40736607042">+40 736 607 042</a>, filip.fagaraseanu@artmark.ro </p>
            </div>
          </div>
          <div class="p-3 xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Robert_Radulescu.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Robert Rădulescu <br/></h4>
              <p> Shop consultant <br/></p>
              <p class="mt-1"><a href="tel:+40736607042">+40 747 016 016</a>, robert.radulescu@artmark.ro </p>
            </div>
          </div>
          <div class="p-3 xl:w-1/2 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full group flex flex-wrap">
            <div class="w-1/3">
              <img src="/assets/img/dda/Ioana_Gavril.jpg" itemprop="thumbnail">
            </div>
            <div class="w-1/2 m-auto">
              <h4 class="font-bold text-normal mt-2"> Ioana Gavril<br/></h4>
              <p> Communication Manager <br/></p>
              <p class="mt-1"><a href="tel:+40736607042">+40 732 373 415</a>, ioana.gavril@artmark.ro </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="how-to" class="flex flex-col w-full mx-auto overflow-hidden px-4 my-8 md:my-16">
      <h2 class="text-4xl text-gray-900 mb-8 border-b self-start">{{ $t('menu.about_us') }}</h2>
      <div class="row sm:grid sm:grid-cols-3 sm:gap-4 flex flex-col">
        <div class="col-4 sm:mb-0 mb-2"><p class="text-sm" style="color: #444;">{{ content[0].about_1 }}</p></div>
        <div class="col-4 sm:mb-0 mb-2"><p class="text-sm" style="color: #444;">{{ content[0].about_2 }}</p></div>
        <div class="col-4 sm:mb-0 mb-2"><p class="text-sm" style="color: #444;">{{ content[0].about_3 }}</p></div>
      </div>
    </div>
  </div>

</template>

<style scoped>

.addToCartDisabled {
  background: #48bb78 !important;
  cursor: pointer;
  display: block;
}

.carousel-cell {
  width: 100%;
  height: auto;
  position: absolute;
  left: 0%;
}

.carousel-cell-image {
  width: 100%;
  display: block;
}

.caption-slider-landing {
  background: white;
  opacity: 0.8;
  width: 100% !important;
  position: absolute;
  bottom: 0 !important;
}
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* Aspect ratio 16:9 */
  height: 0;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: auto; /* Ensures video controls work */
}

/* Floating button */
.video-button {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Semi-transparent */
  color: white;
  text-align: center;
  padding: 12px 0;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  z-index: 10;
  transition: background 0.3s;
}

.video-button:hover {
  background-color: rgba(0, 0, 0, 0.9);
}




</style>

<script>
import Layout from '@/Shared/Layout'
import Dropdown from '@/Shared/Dropdown'
import Flickity from 'vue-flickity'
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: 'Acasă',
      meta: [
        {
          name: 'robots',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {
          name: 'googlebot',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {name: 'title', content: 'Dependent de Arta - Magazinul tau de Artă!'},
        {
          name: 'description',
          content: 'Magazinul tău de artă: pcituri, sculpturi, gravuri, bijuterii, ceasuri, arta decorativa si multe altele. Viziteaza-na sau cumpara online acum!'
        },
        {name: 'keywords', content: 'dependent de arta'},
        // Facebook
        {
          name: 'og:title',
          property: 'og:title',
          content: 'Dependent de Artă - Cel mai mare magazin de artă din România'
        },
        {
          name: 'og:description',
          property: 'og:description',
          content: 'Art Boutique Dependent de Artă este serviciul care vă pune la dispoziție opere de artă pentru achiziția imediată și directă'
        },
        {name: 'og:image', property: 'og:image', content: 'Placeholder Image Link'},
        {name: 'og:url', property: 'og:url', content: window.location.href},
        {name: 'og:type', property: 'og:type', content: 'website'},
      ]
    }
  },
  layout: Layout,
  components: {
    Layout,
    Flickity,
    Dropdown
  },
  props: {
    salesIds: Array,
    twiceDiscountedIds: Array,
    featuredIds: Array,
    bestSellsIds: Array,
    slide: Object,
    mobileBanner: Object,
    content: Array,
    categories: Array,
    anchor: String,
    shop_discount_price: String,
    salesLink: Object,
    twiceDiscountedLink: Object,
  },
  data() {
    return {
      flickityOptions: {
        lazyLoad: true,
        imagesLoaded: true,
        cellAlign: 'center',
        adaptiveHeight: true,
        contain: true,
        autoPlay: false,
        wrapAround: true,
        fade: true,
        pageDots: false,
        prevNextButtons: false,
      },
      toggleMap: false,
      sales: Array,
      twiceDiscounted: Array,
      featured: Array,
      bestSells: Array,
      bestSellsPage: 0,
      featuredPage: 0,
      salesPage: 0,
      twiceDiscountedPage: 0,
    }
  },
  methods: {
    locale: function (artists) {
      return window.location.pathname.split('/')[1];
    },
    makeArtistLink: function (artists) {
      var result = '';
      var locale = this.locale();
      artists.forEach(function (artist, i) {
        var end = '';
        if (i < artists.length - 1 && artists.length > 1) {
          end = '<span>, </span>';
        }
        if (artist.has_page) {
          result = result + '<span id="lotArtist"><a href="/' + locale + '/artist/' + artist.slug + '" style="text-decoration: underline">' + artist.name + end + '</a></span>';
        } else {
          result = result + '<span id="lotArtist">' + artist.name + end + '</span>';
        }
      })
      return result;
    },
    getFeatured: function (ids, changePage = null) {
      axios.post(`/api/get-lots-by-id`, {
        "lotIds": ids,
        "locale": this.locale(),
        "shop": true
      })
          .then(response => {
            this.featured = response.data;
            if (changePage == 'prev' && this.featuredPage >= 1) {
              this.featuredPage--;
            } else if (changePage == 'next' && this.featuredPage < this.featuredIds.length) {
              this.featuredPage++;
            }
          })
          .catch(err => {
            console.log(err)
          })
    },
    getBestSells: function (ids, changePage = null) {
      axios.post(`/api/get-lots-by-id`, {
        "lotIds": ids,
        "locale": this.locale(),
        "shop": true
      })
          .then(response => {
            this.bestSells = response.data;
            if (changePage == 'prev' && this.bestSellsPage >= 1) {
              this.bestSellsPage--;
            } else if (changePage == 'next' && this.bestSellsPage < this.bestSellsIds.length) {
              this.bestSellsPage++;
            }
          })
          .catch(err => {
            console.log(err)
          })
    },
    getSales: function (ids, changePage = null) {
      axios.post(`/api/get-lots-by-id`, {
        "lotIds": ids,
        "locale": this.locale(),
        "shop": true
      })
          .then(response => {
            this.sales = response.data;
            if (changePage == 'prev' && this.salesPage >= 1) {
              this.salesPage--;
            } else if (changePage == 'next' && this.salesPage < this.salesIds.length) {
              this.salesPage++;
            }
          })
          .catch(err => {
            console.log(err)
          })
    },
    getTwiceDiscounted: function (ids, changePage = null) {
      axios.post(`/api/get-lots-by-id`, {
        "lotIds": ids,
        "locale": this.locale(),
        "shop": true
      })
          .then(response => {
            this.twiceDiscounted = response.data;
            if (changePage == 'prev' && this.twiceDiscountedPage >= 1) {
              this.twiceDiscountedPage--;
            } else if (changePage == 'next' && this.twiceDiscountedPage < this.twiceDiscountedIds.length) {
              this.twiceDiscountedPage++;
            }
          })
          .catch(err => {
            console.log(err)
          })
    },
    makeLotTitle: function (lot, short = false) {
      let newArguments = [];
      let title = lot.title;
      if (short) {
        title = lot.shortened_title;
      }

      if (lot.heritage === 1) {
        newArguments.push('C');
      }
      if (lot.heritage === 2) {
        newArguments.push('F');
      }
      if (lot.heritage === 3) {
        newArguments.push('T');
      }
      if (lot.heritage === 4) {
        newArguments.push('IC');
      }
      if (lot.heritage === 5) {
        newArguments.push('IT');
      }
      if (lot.archive_preemption === 1) {
        newArguments.push('A');
      }

      if (newArguments.length > 0) {
        return '<sup>' + newArguments.join(", ") + '</sup> ' + title;
      } else {
        return title;
      }
    },
    inArray(needle) {
      var haystack = Object.keys(this.$page.cart.items);
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    addToCart(id) {
      let locale = this.locale();
      axios({
        method: "post",
        url: '/' + locale + '/cart/add/' + id
      }).then((response) => {
        if (response.data.status == 'success') {
          let carts = document.querySelectorAll('sup.cart_quantity');
          for (let i = 0, len = carts.length; i < len; ++i) {
            let cart = carts[i];
            cart.innerHTML = response.data.quantity;
          }
          if (locale != 'ro') {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/en/cart' style='background: #48bb78;display: block;' class=\"btn-gray a10-btn-padding addToCartDisabled\">Product added!<br/>Go to your cart!</a>";
          } else {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/ro/cart' style='background: #48bb78;display: block' class=\"btn-gray a10-btn-padding addToCartDisabled\">Produs adăugat!<br/>Vezi coșul!</a>";
          }
        } else {
          this.$iziToast.show({
            message: response.data.message,
            color: 'red',
            position: null,
            target: "#iziToast-wrapper_cart_" + id,
            progressBar: false,
            timeout: 500000,
            displayMode: 'replace'//once
          });
        }
      });
    },
    scrollToTarget(target) {
      // const navOffset = 100;
      // const targetPosition = target.getBoundingClientRect().top;
      // const offsetPosition = targetPosition - navOffset + 625; //625 = magic number, satans own cnp
      //
      //
      // window.scrollTo({
      //   top: offsetPosition,
      //   behavior: "smooth"
      // });
      setTimeout(() => {
        const navOffset = 100;
        const targetPosition = target.getBoundingClientRect().top;
        const offsetPosition = targetPosition - navOffset;


        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 200)

    },
    currentPage() {
      return window.location.href
    },
    copyToClipboard(lot) {
      return window.navigator.clipboard.writeText(this.route('shop.lot.view', lot.slug));
    },
    showMap() {
      this.toggleMap = this.toggleMap ? false : true;
    }
  }
  ,
  mounted()
  {
    if (this.featuredIds.length > 0) {
      this.getFeatured(this.featuredIds[this.featuredPage]);
    }
    if (this.bestSellsIds.length > 0) {
      this.getBestSells(this.bestSellsIds[this.bestSellsPage]);
    }
    if (this.salesIds.length > 0) {
      this.getSales(this.salesIds[this.salesPage]);
    }
    if (this.twiceDiscountedIds.length > 0) {
      this.getTwiceDiscounted(this.twiceDiscountedIds[this.twiceDiscountedPage])
    }
    if (this.anchor) {
      let locale = window.location.pathname.split('/')[1];
      this.scrollToTarget(this.$refs[this.anchor])
      history.replaceState('', 'Acasă', '/' + locale);
    }
  }
}
</script>
